<template>
  <vs-popup
    title="Vincular conta ao Google"
    :active.sync="innerActive"
    @close="onClose"
  >
    <p class="social-modal__intro">
      Identificamos que você já possui conta com senha
      <strong v-if="userEmail">({{ userEmail }})</strong>.
      Para usar login com Google, confirme sua senha atual.
    </p>
    <p class="social-modal__warn">
      Ao vincular, sua senha atual será removida e o acesso será apenas pelo Google.
      Para voltar ao login com senha, use "Esqueceu a senha?" — isso desativa o login
      com Google.
    </p>
    <ValidationObserver ref="observer" tag="form" v-slot="{ invalid }" @submit.prevent="submit">
      <ValidationProvider name="senha" rules="required" v-slot="{ errors }">
        <vs-input
          v-model="password"
          class="social-modal__input"
          type="password"
          icon="https"
          label-placeholder="Senha atual"
          placeholder="Senha atual"
          :danger="Boolean(errors.length)"
          :danger-text="errors[0]"
        />
      </ValidationProvider>
      <div class="social-modal__check">
        <vs-checkbox v-model="confirmed">
          Entendo que meu login passará a ser feito pelo Google e que minha senha atual
          será removida.
        </vs-checkbox>
      </div>
      <span v-if="apiError" class="social-modal__error">{{ apiError }}</span>
      <vs-button
        type="button"
        class="social-modal__submit bg-primary"
        :disabled="invalid || !confirmed || submitting"
        @click="submit"
      >
        Vincular e entrar
      </vs-button>
    </ValidationObserver>
  </vs-popup>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import api from "@/services/api";

export default {
  name: "SocialLoginLinkAccountModal",
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    active: { type: Boolean, default: false },
    socialToken: { type: String, default: null },
    userEmail: { type: String, default: "" },
  },
  data() {
    return {
      innerActive: false,
      password: "",
      confirmed: false,
      apiError: "",
      submitting: false,
    };
  },
  watch: {
    active(v) {
      this.innerActive = v;
      if (v) {
        this.password = "";
        this.confirmed = false;
        this.apiError = "";
        this.submitting = false;
      }
    },
    innerActive(v) {
      this.$emit("update:active", v);
    },
  },
  methods: {
    onClose() {
      this.$emit("update:active", false);
    },
    async submit() {
      this.apiError = "";
      const ok = await this.$refs.observer.validate();
      if (!ok || !this.confirmed) return;
      if (!this.socialToken) {
        this.apiError = "Sessão expirada. Abra o login com Google novamente.";
        return;
      }
      this.submitting = true;
      try {
        const { data } = await api.post("/api/v2/auth/social-login/link-account", {
          social_token: this.socialToken,
          password: this.password,
        });
        this.innerActive = false;
        this.$emit("update:active", false);
        this.$emit("completed", {
          token: data.token,
          created_account: false,
          application_id:
            data.application_id != null ? data.application_id : null,
          company_label:
            data.company_label != null ? data.company_label : null,
          vacancy_id: data.vacancy_id != null ? data.vacancy_id : null,
        });
      } catch (e) {
        const errData = e.response && e.response.data;
        if (errData && errData.errors && errData.errors.password) {
          this.apiError = errData.errors.password[0] || "Senha incorreta.";
        } else {
          this.apiError =
            (errData && errData.message) ||
            "Não foi possível vincular a conta. Tente novamente.";
        }
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.social-modal__intro {
  font-size: 14px;
  margin-bottom: 12px;
  line-height: 1.4;
}
.social-modal__warn {
  font-size: 12px;
  color: #5c5c5c;
  margin-bottom: 16px;
  line-height: 1.4;
}
.social-modal__input {
  width: 100%;
  margin-bottom: 12px;
}
.social-modal__check {
  margin: 12px 0;
  font-size: 13px;
}
.social-modal__error {
  display: block;
  color: #ea5455;
  font-size: 12px;
  margin-bottom: 8px;
}
.social-modal__submit {
  width: 100%;
  margin-top: 8px;
}
</style>
